import { Sprout, ArrowLeft } from "lucide-react";

export default function LegalPage({ title, testid, children }) {
  return (
    <div className="min-h-screen bg-[#F8F7F2] text-[#1A251E]" data-testid={testid}>
      <header className="border-b border-[#D8D3C5] bg-[#F8F7F2]/90 backdrop-blur-md sticky top-0 z-40">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2.5" data-testid={`${testid}-logo`}>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#1A382B] text-[#F8F7F2]">
              <Sprout size={18} strokeWidth={1.8} />
            </span>
            <span className="font-display text-xl font-bold text-[#1A382B]">KGA Schönwald e.V.</span>
          </a>
          <a href="/" data-testid={`${testid}-back-link`} className="inline-flex items-center gap-1.5 text-sm font-medium text-[#47544A] hover:text-[#C85A32] transition-colors">
            <ArrowLeft size={15} /> Zur Website
          </a>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 sm:px-6 py-14 md:py-20">
        <p className="eyebrow mb-4">Rechtliches</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1A382B]">{title}</h1>
        <div className="mt-10 space-y-9">{children}</div>
      </main>
      <footer className="border-t border-[#D8D3C5] py-6">
        <p className="mx-auto max-w-3xl px-4 sm:px-6 font-jbm text-xs tracking-wider text-[#6F7E73]">
          © 2026 KGA Schönwald e.V. · Berlin-Rosenthal
        </p>
      </footer>
    </div>
  );
}

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl sm:text-2xl font-semibold text-[#1A382B]">{title}</h2>
    <div className="mt-3 space-y-3 text-base leading-relaxed text-[#47544A]">{children}</div>
  </section>
);
